import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {CollectService} from '../services/collect.service';
import {Collect} from '../models/collect';
import {CieloService} from '../services/cielo.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';

@Component({
  selector: 'app-reports-collect',
  templateUrl: './reports-collect.component.html',
  styleUrls: [ './reports-collect.component.scss' ]
})
export class ReportsCollectComponent implements OnInit {

  @ViewChild('activeSort', {read: MatSort, static: true}) activeSort: MatSort;
  @ViewChild('historySort', {read: MatSort, static: true}) historySort: MatSort;

  public dataSource: MatTableDataSource<any>
  public dataSourceArchived: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'date', 'member', 'status', 'collect', 'value', 'link', 'edit' ];

  constructor (
    private _dialog: MatDialog,
    private _collectService: CollectService,
    private _cieloService: CieloService,
    private _spinnerService: SpinnerService,
    private snackBar: SnackBarIconService
  ) { }

  ngOnInit () {
    this.loadCollects()
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterHistory (filterValue: string) {
    this.dataSourceArchived.filter = filterValue.trim().toLowerCase();
  }

  loadCollects () {
    let waiting = this._spinnerService.show()

    this._collectService.select()
      .subscribe((result) => {
        let array: any[] = []
        let arrayArchived: any[] = []

        result.forEach((item) => {
          let entity = new Collect();
          const dt: any = item.payload.doc.data().date
          entity.id = item.payload.doc.id;
          entity.date = dt.toDate();
          entity.member_name = item.payload.doc.data().member_name;
          entity.collect = item.payload.doc.data().collect;
          entity.status = item.payload.doc.data().status;
          entity.value = item.payload.doc.data().value;
          entity.link = item.payload.doc.data().link
          entity.archived = item.payload.doc.data().archived || false;

          if (entity.archived) {
            arrayArchived.push(entity)
          } else {
            array.push(entity)
          }

        })

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.activeSort;

        this.dataSource.sortingDataAccessor = (item, property) => {
          if (property === 'member') {
            return item.member_name;
          } else {
            return item[ property ];
          }
        };

        this.dataSourceArchived = new MatTableDataSource(arrayArchived);
        this.dataSourceArchived.sort = this.historySort;

        this.dataSourceArchived.sortingDataAccessor = (item, property) => {
          if (property === 'member') {
            return item.member_name;
          } else {
            return item[ property ];
          }
        };

        waiting.close();

      })
  }

  capturePIX () {
    let waiting = this._spinnerService.show()

    this._cieloService.capturePIX()
      .then(() => {
        waiting.close()
      })
      .catch((err) => {
        console.log("ERRO: " + err.message)
      })
  }


  openArchiveDialog (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "<br>Deseja mover este item?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        const archived: boolean = !element.archived;

        this._collectService.archive(element.id, archived)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch(() => {
            console.log('ERRO')
          })

      }
    })
  }

}
